import React from 'react';
import { Button, Typography, Container, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useHistory } from 'react-router-dom';

export function FkoErrorPage() {
  const { push, location } = useHistory();
  const { returnPathFromCallback, message } = location.state as { message: string; returnPathFromCallback: string };

  function onOkClick() {
    push(returnPathFromCallback);
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 8,
        }}
      >
        <FontAwesomeIcon icon={faTriangleExclamation} size="2xl" style={{ color: '#eed744' }} />
        <Typography component="h1" variant="h4" gutterBottom>
          Obs
        </Typography>
        <Typography variant="body1" gutterBottom>
          Du er logget ind i Fasit, men din bruger er muligvis ikke synkroniseret med data fra det fælleskommunale organisationssystem (FKO) eller fra kommunens interne system
          (ADFS).
        </Typography>
        <Typography variant="body1" gutterBottom>
          Det betyder blot at din email, titel, telefonnummer eller team i Fasit kan være forskellige fra oplysninger som er registreret i FKO eller kommunens interne system
          (ADFS), indtil næste gang du logger ind.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Hvis du mener at disse oplysninger burde være ændrede kan du kontakte din lokale administrator.
        </Typography>
        <Typography variant="body1" color="error" gutterBottom>
          Detaljeret fejlbesked: {message}
        </Typography>
        <Box mt={3}>
          <Button variant="contained" color="primary" onClick={onOkClick}>
            Fortsæt til Fasit
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
